import { render, staticRenderFns } from "./onInput-editor.vue?vue&type=template&id=7521a110&scoped=true&"
import script from "./onInput-editor.vue?vue&type=script&lang=js&"
export * from "./onInput-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7521a110",
  null
  
)

export default component.exports